import React from 'react'
import "./separator.scss"

export default function Separator() {
  return (
     <div className="wrapper">
            <div className="separator"></div>
            <div className="separator"></div>
            <div className="separator"></div>
          </div>
  )
}
